(function($){
    $(document).ready(function(){
        autographs.init();      	
    });	
})(jQuery);


var autographs = {	
	init: function() {		
      	this.initElements();
      	this.initCookieMessage();
      	this.initSlideCaption();
      	this.initAddToCart();
      	this.initTagSelect();
      	this.initCatalogDisplay();
      	this.initQuickShop();
	},		
    	
  	
  	initElements: function() {
      $('.product-home img').load(function(){
        $(this).parent().parent().parent().width($(this).width());
      });     
      $(window).load(function(){
      	$('.product-home img').each(function(){
          $(this).parent().parent().parent().width($(this).width());
        });  
      });
      $('.dropdown-holder-bg').width($('#wrapper').width());
      $('.dropdown-holder-bg').height($('#wrapper').height());
      $('.dropdown-holder').width($('.navbar').width());
      if($(window).width() > 992)
      {
        $('.dropdown-menu2').columnize({ columns:6, buildOnce:true }); 
      }
      else
      {
        $('.dropdown-menu2').columnize({ columns:4 }); 
      }      
      var margin = 0;
      $('.dropdown-holder').parent().prevAll().each(function(){
        margin += $(this).width();
      });
      $('.dropdown-holder').css("margin-left", (margin*-1) + "px");
      $(".dropdown").hover(function() {
        $('.dropdown-holder-bg').show();
      });
      $(".dropdown").hover(
        function() {
          $('.dropdown-holder-bg').show();
        }, function() {
          $('.dropdown-holder-bg').hide();
        }
      );
    }, 
  
  
  	initCookieMessage: function() {
      if($.cookie("AOTW") == null){ $("#cookies").show();}
    }, 
  
  
  	addItem : function(form_id) {
        $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: $('#'+form_id).serialize(),
        success: elegance.cartSuccess,
        error: elegance.cartError
      });
    },
    
  	initSlideCaption: function() {
      $('#carousel-home').on('slide.bs.carousel', function () {
        $('.carousel-caption').hide();
        $('.carousel-caption').delay(700).slideDown(400);
      })
    }, 
  
  
    initAddToCart: function() {
      $(".addtocart").click(function(e){   
        var elem = $(this)
        $(elem).prop("disabled", true)
        $('.addtocart').addClass("disabled");        
        e.preventDefault();
        elegance.addItem('add-item-form');        
      })
    }, 
      
        
  	cartSuccess: function() {     
      var elem = $('.addtocart');     
      elem.removeAttr("disabled"); 
      $('.addtocart').removeClass("disabled");
      var quantity = parseInt(jQuery('[name="quantity"]').val(), 10) || 1;
      
      function animate() {
        $(".cart-animation").show();		
        $(".cart-animation").delay(3000).fadeOut(1000, function() {
          $(elem).prop("disabled", false)
        })
      }   
      animate();
      elegance.updateCartAmounts();              
    }   ,
    
  	
  	initTagSelect: function() {
      $("select.loc_on_change").change(function(){
        if($(this).attr("value") == "#") return false;
        window.location = $(this).attr("value");
      })
    },
  
  	
  	initCatalogDisplay: function() {
      $('.show-loop-grid').click(function(){
        $('.prod-loop-grid').show();
        $('.prod-loop-list').hide();
        $('.show-loop-grid').addClass('active');
        $('.show-loop-list').removeClass('active');
      });
      $('.show-loop-list').click(function(){
        $('.prod-loop-grid').hide();
        $('.prod-loop-list').show();
        $('.show-loop-grid').removeClass('active');
        $('.show-loop-list').addClass('active');
      });
    },


	initQuickShop: function() {		
		$('.quick-shop-button').click(function(){
			
			var product_handle = $(this).attr('data-id');
			var template = $('#quick-shop-template').html();
						
			Shopify.getProduct(product_handle, function(product){				
				//strip description from html and trim lenght
				var description = product.description.replace(/<(?:.|\n)*?>/gm, '');
				var description = description.substr(0, 200);
				description = description.substr(0, Math.min(description.length, description.lastIndexOf(" ")));
				description = description + '...';				
				
				template = template.replace(/\[\[PRODUCT_ID\]\]/g, product.id);
				template = template.replace(/\[\[PRODUCT_URL\]\]/g, product.url);
				template = template.replace(/\[\[TITLE\]\]/g, product.title);
				template = template.replace(/\[\[DESCRIPTION\]\]/g, description);
				template = template.replace(/\[\[FULLSIZE_IMAGE_LINK\]\]/g, product.featured_image);
              	template = template.replace(/\[\[URL\]\]/g, product.url);
								
				if(product.available)
				{					                  
                  	if(product.price < product.compare_at_price){
                      template = template.replace(/\[\[PRICE\]\]/g, "<del class='small'>" + Shopify.formatMoney(product.compare_at_price) + "</del> " + Shopify.formatMoney(product.price));
                    } else {
                      template = template.replace(/\[\[PRICE\]\]/g, Shopify.formatMoney(product.price));
                      template = template.replace("<div class=\"sale\">Sale</div>", "");
                    }
				}
				
				var template_obj = $('<div/>').html(template).contents();
        		$('#quick-shop-data').html(template_obj);
				
				elegance.createQuickshopVariants(product, template_obj);				
				elegance.loadQuickShopImage(product, template_obj);				
				elegance.initQuickshopAddToCart();												
			});						
		});
				
	},
  
  
	initQuickshopAddToCart: function() {
		
		$('.ajax-form-submited-wrap').hide();
		
		$('.quick-shop-container ._product-purchase-btn').click(function(){
		
			var variant_id = $('.quick-shop-container select[name=id]').val();
			if(!variant_id)
			{
				variant_id = $('.quick-shop-container input[name=id]').val();
			}
			var quantity = $('.quick-shop-container input[name=quantity]').val();
			
			elegance.initAjaxAddToCart(variant_id, quantity);
		});
	},
  
  
	initAjaxAddToCart: function(variant_id, quantity) {
		$.ajax({
			type: "post",
			url: "/cart/add.js",
			data: 'quantity=' + quantity + '&id=' + variant_id,
			dataType: 'json',			
			success: function( msg ) {				
				$('.cart-animation').show().delay(3000).fadeOut(1000);
				elegance.updateCartAmounts();
			}			
		});
	},
  
  
	updateCartAmounts: function() {
		Shopify.getCart(function(cart){
			 $('#cart-count').html(cart.item_count);
             $('#cart-amount').html(Shopify.formatMoney(cart.total_price));
		});
	},
  
  
	loadQuickShopImage: function(product, template_obj) {
		if(product.featured_image)
		{
			var image = Shopify.resizeImage(product.featured_image, 'medium');				
			var quickImage = new Image();
			quickImage.onload = function() {
				template_obj.find('.image').append(quickImage);						
			};
			quickImage.src = image;
			quickImage.className += 'product-image-quickshop img-responsive div-center';
			quickImage.alt = product.title;
		}		
	},
  
  
	createQuickshopVariants: function(product, template_obj) {
		if(product.variants.length > 1) //multiple variants
		{
			for(var i = 0; i < product.variants.length; i++)
			{
				var variant = product.variants[i];
				var option = '<option value="' + variant.id + '">' + variant.title + '</option>';
				template_obj.find('form.variants > select').append(option);
			}
			
			new Shopify.OptionSelectors("product-select-" + product.id, { product: product, onVariantSelected: selectCallback });			
			if(product.options.length == 1)
			{
				$('.selector-wrapper:eq(0)').prepend('<label>' + product.options[0].name + '</label>');
			}
			template_obj.find('form.variants .selector-wrapper label').each(function(i, v){
              if(product.options[i] != undefined){ $(this).html(product.options[i].name); }
			});
			
		}
		else //single variant
		{
			template_obj.find('form.variants > select').remove();
			var variant_field = '<input type="hidden" name="id" value="' + product.variants[0].id + '">';
			template_obj.find('form.variants').append(variant_field);
		}
	}
}
